<template>
  <!-- <div>自营订单列表 </div> -->

  <div class="shop" v-loading="loading">
    <div class="top">
      <el-date-picker
        v-model="form.created_at_start"
        type="date"
        class="picker"
        style="width: 142px"
        value-format="yyyy-MM-dd"
        size="small"
        placeholder="选择开始时间"
      ></el-date-picker>
      <span class="guodu">~</span>
      <el-date-picker
        v-model="form.created_at_end"
        class="picker"
        type="date"
        style="width: 142px"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="选择结束时间"
      ></el-date-picker>
      <el-input
        class="search input"
        size="small"
        v-model="form.order_no"
        placeholder="订单编号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.out_order_no"
        placeholder="外部订单编号"
        clearable
      ></el-input>
      <el-select
        style="width: 120px"
        size="small"
        v-model="form.apply_status"
        filterable
        class="search"
        placeholder="订单状态"
      >
        <el-option label="全部" :value="0">全部</el-option>
        <el-option label="待处理" :value="1"></el-option>
        <el-option label="已处理" :value="5"></el-option>
      </el-select>
      <el-button class="search" size="small" type="primary" @click="exportPrivateOrder">导出数据</el-button>
      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchOrderData"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="610"
      :cell-style="tc"
      :header-cell-style="tccolor"
      v-loading="loading"
    >
      <el-table-column label="订单编号" prop="order_no"></el-table-column>
      <el-table-column
        label="外部订单编号"
        prop="out_order_no"
      ></el-table-column>
      <el-table-column label="商品信息" prop="goods_name"></el-table-column>
      <el-table-column label="退款原因" prop="apply_reason"></el-table-column>
      <el-table-column label="状态" prop="check_status_name"></el-table-column>
      <el-table-column label="操作" fixed="right" width="260">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="goOrderDetail(scope.row.order_no)"
            >详情</el-button
          >
          <el-button size="mini" @click="closeOrder(scope.row.order_id)"
            >同意取消</el-button
          >
          <el-button size="mini" @click="rejectApply(scope.row.order_id)"
            >驳回申请</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>

    <!--驳回申请-->
    <jdialog
      title="请输入驳回原因"
      :visible.sync="isShowOrderremark"
      width="640px"
    >
      <el-form
        :model="remarkform"
        :rules="rejectRules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="输入密码：" prop="password">
          <el-input
            size="mini"
            v-model="remarkform.password"
            type="password"
            style="width: 120px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注信息：" prop="check_remark">
          <el-input
            type="textarea"
            :rows="4"
            class="remarkarea"
            placeholder="请输入备注信息"
            v-model="remarkform.check_remark"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowOrderremark = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="sureReject"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!--关闭订单备注-->
    <jdialog
      title="关闭订单备注"
      :visible.sync="isCloseOrderremark"
      width="640px"
    >
      <div class="remark">
        <p class="note">
          提示：关闭订单后，资金会原路返还给用户，请确认无误后操作
        </p>
        <el-form
          :model="closeForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="操作选项：" prop="status">
            <el-radio-group v-model="closeForm.status">
              <el-radio label="15">允许退款</el-radio>
              <el-radio label="10">拒绝退款</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="输入密码：" prop="password">
            <el-input
              size="mini"
              v-model="closeForm.password"
              type="password"
              style="width: 120px"
            ></el-input>
          </el-form-item>

          <el-form-item label="确认退款金额：" prop="price">
            <el-input
              size="mini"
              v-model="closeForm.price"
              type="number"
              style="width: 120px"
            ></el-input>
          </el-form-item>

          <el-form-item label="操作备注：" prop="mark">
            <el-input
              size="mini"
              v-model="closeForm.mark"
              placeholder="请输入操作备注"
              type="textarea"
              row="4"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-info">
          <el-button size="mini" @click="isCloseOrderremark = false"
            >取消</el-button
          >
          <el-button size="mini" type="primary" @click="centerorderInfo"
            >确定</el-button
          >
        </div>
      </div>
    </jdialog>
  </div>
</template>

<script>
import {
  orderCloseSearch,
  agreeCancelFn,
  rejectCancelSubmit,
} from '@/api/autarky'
import { API_BASE_URL } from '@/config'
export default {
  data() {
    return {
      loading: false,
      isCloseOrderremark: false,
      rules: {
        status: [
          { required: true, message: '请选择操作选项', trigger: 'change' },
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        price: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        mark: [{ required: true, message: '请输入操作备注', trigger: 'blur' }],
        code: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      rejectRules: {
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        mark: [{ required: true, message: '请输入备注信息', trigger: 'blur' }],
      },
      closeForm: {
        order_id: '',
        status: '',
        price: 0,
        mark: '',
        password: '',
      },
      form: {
        created_at_start: '',
        created_at_end: '',
        order_no: '',
        out_order_no: '',
        apply_status: 0,
        page: 1,
        size: 15,
        filename: '',
        is_export: '',
      },
      total: 0,
      tableData: [],

      //显示订单备注
      isShowOrderremark: false,
      remarkform: {
        password: '',
        check_remark: '',
        order_id: '',
      },
      activities: [],
    }
  },
  mounted() {
    this.getorderListData()
  },
  methods: {
     //导出数据
    exportPrivateOrder() {
      this.form.is_export = 1
      this.getorderListData()
    },
    //搜索
    searchOrderData() {
      this.getorderListData()
    },
    pageChange(page) {
      this.form.page = page
      //申请更多销售日志数据
      this.getorderListData()
    },
    //前往订单详情
    goOrderDetail(order_no) {
      this.$router.push({
        path: './preorderdetail',
        query: { order_no: order_no },
      })
    },
    //驳回
    rejectApply(id) {
      this.remarkform.order_id = id
      this.isShowOrderremark = true
    },
    sureReject() {
      if (!this.remarkform.password) {
        this.$message.error('请输入密码')
        return
      }
      if (!this.remarkform.check_remark) {
        this.$message.error('请填写备注')
        return
      }
      this.rejectCancelSubmitFn()
    },
    //关闭订单
    closeOrder(order_id) {
      this.closeForm.order_id = order_id
      this.isCloseOrderremark = true
    },
    centerorderInfo() {
      if (!this.closeForm.status) {
        this.$message.error('请选择是否允许退款')
        return
      }
      if (!this.closeForm.password) {
        this.$message.error('请输入密码')
        return
      }
      if (!this.closeForm.mark) {
        this.$message.error('请填写备注')
        return
      }

      this.getcloseOrderUpdateData()
    },
    //列表数据
    async getorderListData() {
      if (this.apply_status == 0) {
        this.form.apply_status = ''
      }
      var url =
        'apply_status=' +
        this.form.apply_status +
        '&created_at_start=' +
        this.form.created_at_start +
        '&created_at_end=' +
        this.form.created_at_end +
        '&out_order_no=' +
        this.form.out_order_no +
        '&order_no=' +
        this.form.order_no +
        '&page=' +
        this.form.page +
        '&is_export=' +
        this.form.is_export +
        '&size=' +
        this.form.size

      let res = await orderCloseSearch(url)
      if (res.code === 10000) {
        if (this.form.is_export == 1) {
          this.form.is_export = 0
          this.loading = true
          this.exportOut(res.data.page, res.data.filename)
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.form.is_export = ''
        this.$message.error(res.message)
      }
    },
    async exportOut(page, filename) {
      var url =
        'apply_status=' +
        this.form.apply_status +
        '&created_at_start=' +
        this.form.created_at_start +
        '&created_at_end=' +
        this.form.created_at_end +
        '&out_order_no=' +
        this.form.out_order_no +
        '&order_no=' +
        this.form.order_no +
        '&page=' +
        page +
        '&is_export=1' +
        '&size=' +
        this.form.size +
        '&filename=' +
        filename
      let res = await orderCloseSearch(url)
      if (res.code === 10000) {
        if (res.data.code === 2) {
          this.exportOut(res.data.page, res.data.filename)
        } else if (res.data.code === 1) {
          this.loading = false
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
          )
        } else {
          this.loading = false
          this.$message.error(res.data.message)
        }
      } else {
        this.loading = false
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },
    //关闭订单
    async getcloseOrderUpdateData() {
      let res = await agreeCancelFn(this.closeForm)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.isCloseOrderremark = false
        this.getorderListData()
      } else {
        this.$message.error(res.message)
      }
    },
    async rejectCancelSubmitFn() {
      let res = await rejectCancelSubmit(this.remarkform)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.isShowOrderremark = false
        this.getorderListData()
      } else {
        this.$message.error(res.message)
      }
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;

  .top {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 20px;

    .search {
      margin-left: 10px;
    }

    .input {
      width: 140px;
    }

    .guodu {
      line-height: 30px;
    }
  }

  .align {
    text-align: center;
    padding-bottom: 20px;
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }

  .demo-ruleForm {
    padding: 20px;

    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }

  ::v-deep.el-loading-spinner {
    top: 30% !important;
  }
  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
    }
    .btn-info {
      text-align: center;
    }
  }
}
</style>
